import { Location } from '@angular/common';
import { Component, inject } from '@angular/core';
import { FwButtonComponent, FwLayoutContextComponent } from '@flywheel-io/vision';

@Component({
  selector: 'app-error-404',
  imports: [FwButtonComponent, FwLayoutContextComponent],
  template: `
    <fw-layout-context
      description="The page you are looking for does not exist."
      icon="search-loop"
      iconColor="danger"
      title="404 Error"
    >
      <fw-button variant="outline" (click)="location.back()">Go back</fw-button>
    </fw-layout-context>
  `,
  styles: [
    `
      :host {
        width: 100%;
        height: 100%;
        display: flex;
        justify-content: center;
      }
    `,
  ],
})
export class Error404Component {
  location = inject(Location);
}
